import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import ReconnectingWebSocket from "reconnecting-websocket";

const SOCKET_URL = process.env.REACT_APP_CHATAPP_SOCKET_URL || "wss://4l7xb4day3.execute-api.ap-south-1.amazonaws.com/beta";
//const SOCKET_URL = 'ws://localhost:3001' || "wss://4l7xb4day3.execute-api.ap-south-1.amazonaws.com/beta";

console.log(process.env.REACT_APP_CHATAPP_SOCKET_URL);

interface ISocketProviderParams {
  children: ReactNode
}

const SocketContext = createContext<ReconnectingWebSocket | null>(null);

const useSocketContext = () => useContext(SocketContext);

const SocketProvider = ({ children }: ISocketProviderParams) => {
  const [socketRef, setSocketRef] = useState<ReconnectingWebSocket | null>(null);
  useEffect(() => {
    const locationPath = window.location.pathname.replace("/admin/chat_app_frontend","")
    const chatId = locationPath.split("/")[1];
    console.log(chatId);
    const ws = new ReconnectingWebSocket(
      `${SOCKET_URL}/?chatId=${chatId}`,
      [],
      {
        connectionTimeout:20000,
        maxReconnectionDelay: 10000,
        minReconnectionDelay: 1000 + Math.random() * 2000,
        reconnectionDelayGrowFactor: 1.4,
        debug: true
      }
    );
    setSocketRef(ws);

    ws.addEventListener("open", (event) => {
      console.log("onOpen", event)
    })

    ws.addEventListener("close", (event) => {
      console.log("onClose", event)
    })


    ws.onmessage = (event: any) => {
      const eventData = JSON.parse(event.data) || {};
      console.log("New Message from server", event);
      switch (eventData.type) {
        case "fetchMessages":
          break;
        default:
          console.log("No handling for ", eventData.type);
          break;
      }
    };
    
  }, []);
  return (
    <SocketContext.Provider value={socketRef}>
      {children}
    </SocketContext.Provider>
  );
};

export { useSocketContext, SocketProvider };
